import { send } from "../../send";

export const newscreen = {
    // 获取仓储信息
    getInventory(parmas, expend) {
        return send("POST", "/api/company/waste/inventory", parmas, expend);
    },
    // 获取统计数据
    getStatistics(parmas, expend) {
        return send("POST", "/api/company/waste/statistics", parmas, expend);
    },
    // 获取统计数据2
    getStatistics2(parmas, expend) {
        return send("POST", "/api/company/waste/statistics2", parmas, expend);
    }
}